import { render, staticRenderFns } from "./rule-form-tab1.vue?vue&type=template&id=da3e0ec8&scoped=true&"
import script from "./rule-form-tab1.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3e0ec8",
  null
  
)

export default component.exports